import { Component, OnInit, AfterViewInit, Renderer2, ElementRef, Inject } from '@angular/core';
import { ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormArray } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from 'src/app/blacklist/service/data.service';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
//import { DeleteCampaignDialogComponent } from '../delete-campaign-dialog/delete-campaign-dialog.component';
import { DataTableDirective } from 'angular-datatables';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-add-campaign',
  templateUrl: './add-campaign.component.html',
  styleUrls: ['./add-campaign.component.scss']
})
export class AddCampaignComponent implements OnInit {
  showTable: boolean;
  campaignForm: FormGroup;
  campaignGroup: FormGroup;
  public sessionStorage = sessionStorage;
  // @ViewChild('ModalDirective','') modal: ModalDirective;
  @ViewChild('closebutton', { static: true }) closeButton: ElementRef;

  closeResult: string;
  subcriberTypemapping = {
    '1': 'Prepaid',
    '2': 'Postpaid',
    '3': 'Standard'
  };
  eventTypeMapping = {
    '1': 'GSM UL',
    '2': 'GSM CL',
    '3': 'GPRS UL',
    '4': 'GPRS CL'
  }
  messageMapping = {
    '1': 'English',
    '2': 'French',
    '3': 'Spanish',
    '4': 'Polish'
  }
  tadigMapping = {
    '1': 'All',
    '2': 'TADIG1',
    '3': 'TADIG2',
    '4': 'TADIG3'
  }
  countryMapping = {
    '1': 'All',
    '2': 'India',
    '3': 'USA'
  }
  affiliatesMapping = {
    '1': 'All',
    '2': 'Affiliates1',
    '3': 'Affiliates2',
    '4': 'Affiliates3'
  }
  withTadigMapping = {
    '': 'All',
    '2': 'WithTadig1',
    '3': 'WithTadig2',
    '4': 'WithTadig3'
  }
  VPMNCountryMapping = {
    '1': 'All',
    '2': 'India',
    '3': 'USA'
  }
  roamingPartnersMapping = {
    '1': 'All',
    '2': 'Partners1',
    '3': 'Partners2',
    '4': 'Partners3'
  }

  tableData = [];
  callVPMNNetwork: boolean;
  campaignData = [];
  campaignData1 = [];
  campaignData2 = [];
  campaignData3 = [];
  campaignData4 = [];
  HPMNCountry: [];
  HPMNNetwork: [];
  HPMNTadig: [];
  campaignId = [];
  isCamapaignEdit = false;
  isCampaignView = true;
  editIndex = null;
  uniqueArray: any = [];
  template: String;
  type = 'home'
  titleHeader = 'Add Campaign';
  buttonCount = 0;
  eventCount = 4;
  // We use this trigger because fetching the list of persons can be quite long,
  // thus we ensure the data is fetched before rendering

  //miltiselect dropdown
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  tabName: string = 'tab_1';
  editData: any;

  constructor(private modalService: NgbModal,
    private formBuilder: FormBuilder, private spinnerService: Ng4LoadingSpinnerService, private dataService: DataService,
    private router: Router, private endpointsService: EndpointsService, @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog,
    private backendApiService: BackendApiService,
    private renderer: Renderer2) { }

  open(content, val: any) {


    if (val == 'new') {
      this.reset();
    } else {
      this.tabName = 'tab_5';
    }

    this.isCamapaignEdit = false;
    this.isCampaignView = true;


    this.modalService.open(content, { keyboard: false, backdrop: 'static' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed `;
    });
  }



  ngOnInit(): void {
    this.createCampaignForm();
    if (this.data.type !== 'Creation') {
      if (this.data.type == 'Edit') {
        this.titleHeader = 'Edit Campaign';
        console.log(' this.data.dataValues ', this.data.dataValues);
        this.editData = this.data.dataValues;
        this.editRecord(this.editData);
      }
      else {
        this.titleHeader = 'View Campaign';
        console.log(' this.data.dataValues ', this.data.dataValues);
        this.editData = this.data.dataValues;
        this.viewRecord(this.editData);
      }
    }
  }
  createCampaignForm() {
    this.campaignForm = this.formBuilder.group({
      tadig: [sessionStorage.getItem('homeTadg')],
      country: [sessionStorage.getItem('homeCountry')],
      affiliates: [sessionStorage.getItem('homeOp')],
      withTadig: ['ALL'],
      rCountry: ['ALL'],
      roamingPartners: ['ALL'],
      language: [''],
      //selectedItems:[],
      startDate: [''],
      endDate: [''],
      startTime: [''],
      endTime: [''],
      campaignId: [],
      materialExampleRadios: [''],
      template: [],
      campaignName: [''],
      campaign: [],
      mtnToMtn: [],
      overview: [],
      events: this.formBuilder.array([
        this.formBuilder.group({
          subcriberType: [],
          previousVisit: [],
          eventType: [],
          stayDuration: [],
          currentLocation: [],
          messageId: [],
          rta: [],
          previousValue: []
        })
      ]),
      msgContent: this.formBuilder.array([
        this.formBuilder.group({
          messageId: [],
          msgLanguage: [],
          messageContent: [],
          rtaMessageText: [],
          rtaMessageLanguage: []
        })
      ])
    });
    this.getApiOnLoad();
    this.getCountry();

    this.dropdownList = [
      { item_id: 1, item_text: 'GSM UL' },
      { item_id: 2, item_text: 'GSM CL' },
      { item_id: 3, item_text: 'GPRS UL' },
      { item_id: 4, item_text: 'GPRS CL' }
    ];
    //this.selectedItems = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }
  nextBackAction(name: string) {
    this.tabName = name;
  }
  onItemSelect(item: any) {

  }
  onSelectAll(items: any) {

  }

  reset() {
    this.campaignForm.reset();
    this.campaignForm.controls.tadig.setValue(sessionStorage.getItem('homeTadg'));
    this.campaignForm.controls.country.setValue(sessionStorage.getItem('homeCountry'));
    this.campaignForm.controls.affiliates.setValue(sessionStorage.getItem('homeOp'));
    this.campaignForm.controls.withTadig.setValue('1');
    this.campaignForm.controls.rCountry.setValue('1');
    this.campaignForm.controls.roamingPartners.setValue('1');
    this.campaignForm.controls.language.setValue('1');
    this.tabName = "tab_1";
  }
  editRecord(campaignData) {
    console.log(campaignData);
    // this.campaignForm.reset();
    //this.spinnerService.show();
    this.campaignForm.controls.campaignName.patchValue(campaignData.campaignName);
    this.campaignForm.controls.campaignId.patchValue(campaignData.campaignId);
    this.campaignForm.controls.country.patchValue(campaignData.hpmnCountry);

    this.campaignForm.controls.rCountry.patchValue(campaignData.vpmnCountry);
    this.campaignForm.controls.roamingPartners.patchValue(campaignData.vpmnNetwork);
    this.campaignForm.controls.withTadig.patchValue(campaignData.vpmnTadIg);

    this.getCountry();
    this.getVpmnNetworkAccordingToCountry(campaignData.vpmnCountry)


    this.campaignForm.controls.affiliates.patchValue(campaignData.hpmnNetwork);
    this.campaignForm.controls.tadig.patchValue(campaignData.hpmnTadIg);
    this.campaignForm.controls.materialExampleRadios.patchValue(campaignData.never);
    this.campaignForm.controls.startDate.patchValue(this.dateFormate(campaignData.startDate));
    this.campaignForm.controls.endDate.patchValue(this.dateFormate(campaignData.endDate));
    // this.open(content, 'edit');
    // this.editIndex = index;
    this.isCamapaignEdit = true;
    this.isCampaignView = true;
    this.setEditRecords(campaignData)

  }

  setEditRecords(campaignData) {

    for (let index = 0; index < this.allEvents.length; index++) {
      this.allEvents.removeAt(index);
    }

    for (let index = 0; index < this.allEvents.length; index++) {
      this.allEvents.removeAt(index);
    }

    for (let index = 0; index < this.allMessages.length; index++) {
      this.allMessages.removeAt(index);
    }

    let eventValArrayVal = campaignData.eventValArray;
    if (eventValArrayVal) {
      eventValArrayVal.forEach(element => {
        this.allEvents.push(this.formBuilder.group({
          subcriberType: [element.subscriberType],
          previousVisit: [element.previousVisit],
          eventType: [element.eventType],
          stayDuration: [element.stayDuration],
          currentLocation: [element.currentLocation],
          messageId: [element.messageId],
          rta: [element.rta],
          previousValue: [element.previousValue]
        })
        );
      });
    }
    let messageArrayVal = campaignData.messageArray;
    if (messageArrayVal) {
      messageArrayVal.forEach(element => {
        this.allMessages.push(
          this.formBuilder.group(
            {
              messageId: [element.messageId],
              messageContent: [element.messageText],
              msgLanguage: [element.messageLanguage],
              // messageContent: [element.messageContent],
              rtaMessageText: [element.rtaMessageText],
              rtaMessageLanguage: [element.rtaMessageLanguage]
            }));
      });
    }
  }

  viewRecord(campaignData) {
    this.tabName = 'tab_5';
    this.campaignForm.controls.campaignName.patchValue(campaignData.campaignName);
    this.campaignForm.controls.country.patchValue(campaignData.hpmnCountry);
    this.campaignForm.controls.affiliates.patchValue(campaignData.hpmnNetwork);
    this.campaignForm.controls.tadig.patchValue(campaignData.hpmnTadIg);

    this.campaignForm.controls.rCountry.patchValue(campaignData.vpmnCountry);
    this.campaignForm.controls.roamingPartners.patchValue(campaignData.vpmnNetwork);
    this.campaignForm.controls.withTadig.patchValue(campaignData.vpmnTadIg);
    this.getCountry();
    this.getVpmnNetworkAccordingToCountry(campaignData.vpmnCountry)

    this.campaignForm.controls.materialExampleRadios.patchValue(campaignData.never);
    this.campaignForm.controls.startDate.patchValue(this.dateFormate(campaignData.startDate));
    this.campaignForm.controls.endDate.patchValue(this.dateFormate(campaignData.endDate));
    // this.open(content, 'view');
    this.isCampaignView = true;
    this.setEditRecords(campaignData)
  }

  isMessageIdDuplicate(eventControles, index) {
    let isDuplidate = false;
    let messageId = eventControles[index].controls.messageId.value;
    let subcriberType = eventControles[index].controls.subcriberType.value;
    if (!messageId) return false;

    eventControles.forEach((element, eIndex) => {
      if (eIndex !== index) {
        if (element.controls.messageId.value === messageId && (eIndex + 1) != eventControles.length && element.controls.subcriberType.value === subcriberType) {
          isDuplidate = true;
        }
      }
    });
    return isDuplidate;
  }

  isFormDisable() {
    if (!this.campaignForm.valid) {
      return true;
    }
    let duplicates = [];
    let isDuplicate = false;
    this.campaignForm.controls.events.value.forEach((ele) => {
      if (ele.messageId && duplicates.indexOf(ele.messageId + ele.subcriberType) == -1) {
        duplicates.push(ele.messageId + ele.subcriberType);
      } else if (ele.messageId && !isDuplicate) {
        isDuplicate = true;
      }
    });
    return isDuplicate;
  }

  setData(campaignFormData) {

    localStorage.setItem('campaignData', JSON.stringify(campaignFormData));
  }

  getData() {
    var data = localStorage.getItem('campaignData');
    if (!data) {
      return [];
    }
    return JSON.parse(data);
  }

  dateFormate(date) {
    let dateFormate = new Date(date).toISOString();
    let sp_date = dateFormate.split("T");
    // let jn_date = sp_date.join(" ");
    // let new_date = jn_date.substr(0, 16);
    return sp_date[0];
  }

  getEventDetails() {
    let eventArray = []
    if (this.campaignForm.value.events) {
      for (let i = 0; i < this.campaignForm.value.events.length; i++) {
        eventArray.push({
          "currentLocation": this.campaignForm.value.events[i].currentLocation,
          "eventType": this.campaignForm.value.events[i].eventType,
          "messageId": (this.campaignForm.value.events[i].messageId) ? this.campaignForm.value.events[i].messageId : "",
          "previousValue": this.campaignForm.value.events[i].previousValue,
          "previousVisit": this.campaignForm.value.events[i].previousVisit,
          "rta": this.campaignForm.value.events[i].rta,
          "stayDuration": this.campaignForm.value.events[i].stayDuration,
          "subscriberType": (this.campaignForm.value.events[i].subcriberType) ? this.campaignForm.value.events[i].subcriberType : ""
        })
      }
    }
    return eventArray;
  }

  getMsgDetails() {
    let messageArray = []
    if (this.campaignForm.value.msgContent) {
      for (let i = 0; i < this.campaignForm.value.msgContent.length; i++) {
        messageArray.push({
          "messageId": (this.campaignForm.value.msgContent[i].messageId) ? this.campaignForm.value.msgContent[i].messageId : "",
          "messageLanguage": this.campaignForm.value.msgContent[i].msgLanguage,
          "messageText": this.campaignForm.value.msgContent[i].messageContent,
          "rtaMessageText": this.campaignForm.value.msgContent[i].rtaMessageText,
          "rtaMessageLanguage": this.campaignForm.value.msgContent[i].rtaMessageLanguage,
        })
      }
    }
    return messageArray;
  }

  editCampaignSubmit(closeModal) {
    this.template = 'No';
    if (this.campaignForm.get('rCountry').value != 'ALL'
      && this.campaignForm.get('campaignName').value != ''
      && this.campaignForm.value.startDate != ''
      && this.campaignForm.value.endDate != '') {
        console.log( '1' , this.campaignForm.value);
        console.log( '2' , this.dateFormate(this.campaignForm.get('startDate').value));
        console.log( '3' , this.dateFormate(this.campaignForm.get('endDate').value));
      if (this.dateFormate(this.campaignForm.get('startDate').value) <= this.dateFormate(this.campaignForm.get('endDate').value)) {
    let JsonData =
    {
      "hpmnTadIg": this.campaignForm.get('tadig').value,
      "hpmnCountry": this.campaignForm.get('country').value,
      "hpmnNetwork": this.campaignForm.get('affiliates').value,
      "vpmnTadIg": [
        this.campaignForm.get('withTadig').value,
      ],
      "vpmnCountry": this.campaignForm.get('roamingPartners').value,
      "vpmnNetwork": this.campaignForm.get('rCountry').value,
      "startDate": this.dateFormate(this.campaignForm.value.startDate),
      "endDate": this.dateFormate(this.campaignForm.value.endDate),
      "startTime": this.campaignForm.get('startTime').value,
      "endTime": this.campaignForm.get('endTime').value,
      "never": this.campaignForm.get('materialExampleRadios').value,
      "template": this.template,
      "campaignName": this.campaignForm.get('campaignName').value,
      "campaignId": this.campaignForm.get('campaignId').value,
      "eventValArray": this.getEventDetails(),
      "messageArray": this.getMsgDetails()
    }

    this.backendApiService.postApi(this.endpointsService.URL_EDIT_CAMPAIGN, JsonData)
      .then(response => {

        this.spinnerService.hide();
        if (response) {
          alert('Campaign Updated successfully');
          this.closeModal();
        } else {
          alert('Campaign Not Updated');
        }
        this.getApiOnLoad();
      });
    }
      else {
        alert("Start Date must be less then End Date");
        return;
      }
    }
    else {
      alert("Please Select VPMN Country & Campaign Name & Start & End Dates");
      return;
    }

  }
  getApiOnLoad() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.URL_GET_CAMPAIGN + '&userName=' + sessionStorage.getItem('ecowas_user_name');

    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.campaignData = response;
    });
    this.getCountry();
  }

  async getCountry() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.campaignData1 = response;
    });
    // const apiUrl = this.endpointsService.URL_GET_CAMPAIGN_COUNTRY + '&type=home';
    // this.backendApiService.callToApi(apiUrl).subscribe(response => {
    //   this.campaignData1 = response;
    // });

  }



  // async getVpmnTadigList(country: string) {
  //   // const apiUrl1 = this.endpointsService.URL_GET_CAMPAIGN_NETWORK +
  //   //   '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=Benin';

  //   // this.backendApiService.callToApi(apiUrl1).subscribe(response => {
  //   //   this.campaignData2 = response;

  //   // });
  //   const apiUrl1 = this.endpointsService.URL_GET_CAMPAIGN_TADIG +
  //     '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&type=home' ;
  //   this.backendApiService.callToApi(apiUrl1).subscribe(response => {
  //     this.campaignData3 = response;
  //   });
  //   //this.getTadig();
  // }


  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target && event.target.value === '1') {
      this.callVPMNNetwork = false;
      this.campaignForm.controls.roamingPartners.setValue('1', { onlySelf: true });
    } else {
      this.spinnerService.show();
      if (event.target) {
        this.getVpmnNetworkList(event.target.value).then();
      } else {
        this.getVpmnNetworkList(event).then();
      }
    }
  }
  getVpmnNetworkAccordingToCountry1(event: any) {
    if (event.target && event.target.value === '1') {
      this.callVPMNNetwork = false;
      this.campaignForm.controls.vpmnNetwork.setValue('1', { onlySelf: true });
    } else {
      this.spinnerService.show();
      if (event.target) {
        this.getVpmnNetworkList1(event.target.value).then();
      } else {
        this.getVpmnNetworkList1(event).then();
      }
    }
  }

  // async getVpmnNetworkList(country: string) {
  //   const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
  //     '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
  //   this.backendApiService.callToApi(apiUrl1).subscribe(response => {
  //     this.campaignData2 = response;
  //   });
  //   //this.getTadig();
  //   this.getVpmnTadig();
  //   this.getVpmnTadig1();
  // }
  async getVpmnNetworkList1(country: string) {
    this.campaignData2 = await this.backendApiService.callToApi(this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country)
      .toPromise();

    if (this.campaignData2 === null) {
      alert('api response null. please contact administrator');
      return;
    } else {
      this.spinnerService.hide();
      if (this.campaignData2.length !== 0) {
        this.campaignGroup.controls.vpmnNetwork.
          setValue(this.campaignData2[0].operator);
        // this.getVpmnTadig();
        this.getVpmnTadig1();
        this.callVPMNNetwork = true;
      } else {
        this.callVPMNNetwork = false;
      }
      return;
    }
  }
  // async getVpmnNetworkList(country: string) {
  //   this.campaignData2 = await this.backendApiService.callToApi(this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
  //     '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country)
  //     .toPromise();

  //   if (this.campaignData2 === null) {
  //     alert('api response null. please contact administrator');
  //     return;
  //   } else {
  //     this.spinnerService.hide();
  //     if (this.campaignData2.length !== 0) {
  //       this.campaignForm.controls.roamingPartners.
  //         setValue(this.campaignData2[0].operator);
  //       this.getVpmnTadig();
  //       this.callVPMNNetwork = true;
  //     } else {
  //       this.callVPMNNetwork = false;
  //     }
  //     return;
  //   }
  // }

  async getVpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.campaignData2 = response;
      // if (this.campaignData2 && this.campaignData2.length > 0) {
      //   this.campaignForm.controls.roamingPartners.setValue(response[0].operator, { onlySelf: true });
      // }
      this.getVpmnTadig();
    });
  }

  getHpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === '1') {
      this.callVPMNNetwork = false;
      this.campaignForm.controls.vpmnNetwork.setValue('1', { onlySelf: true });
    } else {
      this.spinnerService.show();
      this.getHpmnNetworkList(event.target.value).then();
    }
  }

  async getHpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.HPMNNetwork = response;
    });
    //this.getTadig();
    this.getHpmnTadig();
  }

  getHpmnTadig() {
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.campaignGroup.get('hpmnCountry').value +
      '&operator=' + this.campaignGroup.get('hpmnNetwork').value).
      subscribe(response => {
        if (response.length === 0) {
          return;
        }
        this.HPMNTadig = response;
        // this.searchRetailDB.get('vpmnTadig')
        //   .setValue(response[0].tapCode, {onlySelf: true});
      });
  }
  getVpmnTadig() {
    if(this.campaignForm.controls.rCountry.value == 'ALL' || this.campaignForm.controls.roamingPartners.value == 'ALL'){
      this.campaignData3 = [];
      this.campaignForm.get('withTadig')
          .setValue('ALL', {onlySelf: true});
    }
    else{
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.campaignForm.get('rCountry').value +
      '&operator=' + this.campaignForm.get('roamingPartners').value).
      subscribe(response => {
        if (response.length === 0) {
          return;
        }
        this.campaignData3 = response;
        this.campaignForm.get('withTadig')
          .setValue(response[0].tapCode, { onlySelf: true });
      });
    }
  }

  getVpmnTadig1() {
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.campaignGroup.get('vpmnCountry').value +
      '&operator=' + this.campaignGroup.get('vpmnNetwork').value).
      subscribe(response => {
        if (response.length === 0) {
          return;
        }
        this.campaignData4 = response;
        this.campaignGroup.get('vpmnTadig')
          .setValue(response[0].tapCode, { onlySelf: true });
      });
  }
  // getTadig() {
  //   const apiUrl = this.endpointsService.URL_GET_CAMPAIGN_TADIG +
  //     '&userName=' + sessionStorage.getItem('ecowas_user_name');

  //   this.backendApiService.callToApi(apiUrl).subscribe(response => {
  //     this.campaignData3 = response;

  //   });
  // }
  ///////// This is new ////////
  get allEvents() {
    return this.campaignForm.get('events') as FormArray;
  }
  get allMessages() {
    return this.campaignForm.get('msgContent') as FormArray;
  }
  ///////////End ////////////////
  triggerClick() {
    let el: HTMLElement = this.closeButton.nativeElement as HTMLElement;
    el.click();
  }
  addEvents() {
    if (this.buttonCount > 3) {
      alert("You can add only 5 times ");
      return;
    }
    else {
      this.buttonCount++;
      this.allEvents.push(
        this.formBuilder.group(
          {
            subcriberType: [],
            previousVisit: [],
            eventType: [],
            stayDuration: [],
            currentLocation: [],
            messageId: [],
            rta: [],
            previousValue: []
          }));
      this.allMessages.push(
        this.formBuilder.group(
          {
            messageId: [],
            msgLanguage: [],
            messageContent: [],
            rtaMessageText: [],
            rtaMessageLanguage: []
          }));

      console.log(this.buttonCount);
    }
  }

  deleteEvents(index) {
    this.buttonCount = this.buttonCount-1;
    this.allEvents.removeAt(index);
    this.allMessages.removeAt(index);
  }

  changeDateEvent(targetCalendarId: any) {
    targetCalendarId.toggle();
  }



  saveTemplate(closeModal) {
    if (this.campaignForm.get('rCountry').value != 'ALL'
    && this.campaignForm.get('campaignName').value != ''
    && this.campaignForm.value.startDate != ''
    && this.campaignForm.value.endDate != '') {
      if (this.campaignForm.get('startDate').value <= this.campaignForm.get('endDate').value) {
        this.template = 'Yes';
        let JsonData =
        {
          "hpmnTadIg": this.campaignForm.get('tadig').value,
          "hpmnCountry": this.campaignForm.get('country').value,
          "hpmnNetwork": this.campaignForm.get('affiliates').value,
          "vpmnTadIg": [
            this.campaignForm.get('withTadig').value,
          ],
          "vpmnCountry": this.campaignForm.get('rCountry').value,
          "vpmnNetwork": this.campaignForm.get('roamingPartners').value,
          "startDate": this.dateFormate(this.campaignForm.value.startDate),
          "endDate": this.dateFormate(this.campaignForm.value.endDate),
          "startTime": this.campaignForm.get('startTime').value,
          "endTime": this.campaignForm.get('endTime').value,
          "never": this.campaignForm.get('materialExampleRadios').value,
          "template": this.template,
          "campaignName": this.campaignForm.get('campaignName').value,
          "eventValArray": this.getEventDetails(),
          "messageArray": this.getMsgDetails()
        }

        this.backendApiService.postApi(this.endpointsService.URL_ADD_CAMPAIGN, JsonData)
          .then(response => {

            this.spinnerService.hide();
            if (response) {
              alert('Campaign Added successfully');
              this.closeModal();
            } else {
              alert('Campaign Not Added. Please check with administrator');
              this.closeModal();
            }
            this.getApiOnLoad();
          });
      }
      else {
        alert("Start Date must be less then End Date");
        return;
      }
    }
    else {
      alert("Please Select VPMN Country & Campaign Name & Start & End Dates");
      return;
    }

  }

  startCampaignSubmit(closeModal) {
    if (this.campaignForm.get('rCountry').value != 'ALL'
      && this.campaignForm.get('campaignName').value != ''
      && this.campaignForm.value.startDate != ''
      && this.campaignForm.value.endDate != '') {
      if (this.campaignForm.get('startDate').value <= this.campaignForm.get('endDate').value) {
        this.template = 'No';
        let JsonData =
        {
          "hpmnTadIg": this.campaignForm.get('tadig').value,
          "hpmnCountry": this.campaignForm.get('country').value,
          "hpmnNetwork": this.campaignForm.get('affiliates').value,
          "vpmnTadIg": [
            this.campaignForm.get('withTadig').value,
          ],
          "vpmnCountry": this.campaignForm.get('rCountry').value,
          "vpmnNetwork": this.campaignForm.get('roamingPartners').value,
          "startDate": this.dateFormate(this.campaignForm.value.startDate),
          "endDate": this.dateFormate(this.campaignForm.value.endDate),
          "startTime": this.campaignForm.get('startTime').value,
          "endTime": this.campaignForm.get('endTime').value,
          "never": this.campaignForm.get('materialExampleRadios').value,
          "template": this.template,
          "campaignName": this.campaignForm.get('campaignName').value,
          "eventValArray": this.getEventDetails(),
          "messageArray": this.getMsgDetails()
        }

        this.backendApiService.postApi(this.endpointsService.URL_ADD_CAMPAIGN, JsonData)
          .then(response => {

            this.spinnerService.hide();
            if (response) {
              alert('Campaign Added successfully');
              this.closeModal();
            } else {
              alert('Campaign Not Added. Please check with administrator');
              this.closeModal();
            }
            this.getApiOnLoad();
          });
      }
      else {
        alert("Start Date must be less then End Date");
        return;
      }
    }
    else {
      alert("Please Select VPMN Country & Campaign Name & Start & End Dates");
      return;
    }
  }


  closeModal() {
    this.dialog.closeAll();
  }



}
